import { useState, useEffect, forwardRef } from   'react';
import { useParams, useNavigate} from 'react-router-dom';
import MenuEnlacesDX from './Componentes/MenuEnlacesDX';
import HeaderDXReloj from './Componentes/HeaderDXReloj';
import SeccionPageHeader from '../Utils/SeccionPageHeader';
import CargandoSpinner from '../Utils/CargandoSpinner';
import SweetAlert2 from 'react-sweetalert2';
import { Tooltip } from 'react-tooltip';
import { useAuth } from '../../Auth/AuthContext';
import apiService from './../../Auth/apiService';
import { useForm, Controller } from 'react-hook-form';
import DatePicker from 'react-datepicker';
import { FaCalendar } from 'react-icons/fa';
import moment from 'moment';

// CustomInput moved outside of DXDiferenciales for better performance and prop validation
const CustomInput = forwardRef(function CustomInput({ value, onClick }, ref) {
    // Keyboard accessibility: trigger onClick for Enter/Space
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClick?.(e);
        }
    };
    return (
        <button
            type="button"
            className="custom-input"
            onClick={onClick}
            onKeyDown={handleKeyDown}
            ref={ref}
            aria-label="Seleccionar fecha"
            style={{ display: 'flex', alignItems: 'center', border: 'none', background: 'none', padding: 0 }}
        >
            <input value={value} readOnly className='widthCalendar' tabIndex={-1} style={{ pointerEvents: 'none' }} />
            <FaCalendar />
        </button>
    );
});

export default function DXDiferenciales() {
    const { iddx } = useParams();
    const { idrecepcion } = useParams();
    const { token, user } = useAuth();
    const [estadoDx, setEstadoDx] = useState('');
    const Navigate = useNavigate();
    const [swalProps, setSwalProps] = useState({});
    const [Cargando, setCargando] = useState(false);
    const [sexos, setSexos] = useState([]);
    const [etnias, setEtnias] = useState([]);
    const [pendingResetData, setPendingResetData] = useState(null);
    const [discapacidadcausas, setDiscapacidadcausas] = useState([]);
    const [gestantes, setGestantes] = useState([]);
    const [enfermedades, setEnfermedades] = useState([]);
    const [fechaInicioAtencion, setFechaInicioAtencion] = useState(null);
    const { watch, handleSubmit, register, setValue, reset, control, formState: { errors }} = useForm({ 
            defaultValues: {
                iddx: '',
                dif_2_3_etnia: '',
            } 
        }
        );
    const Mensaje = (title, text, icon) => {
        setSwalProps({
            show: true,
            title,
            text,
            icon, // 'success' or 'error'
        });
    };
    useEffect(() => {
        if (pendingResetData && sexos.length > 0) {
            FormReset(pendingResetData);
            setPendingResetData(null);
        }
    }, [pendingResetData, sexos]);
    useEffect(() => {
        const fethcData = async () => {
            const url = '/diagnostico/crearformulariodiferenciales';
            const obj = {idDx: iddx }
            await apiService.post(url, obj, token)
            .then((response) => {
                setFechaInicioAtencion(response.data.recepcion.repFechahoraatencion);
                setEstadoDx(response.data.estadodx);
                if(response.data.sexos) {
                    setSexos(response.data.sexos);
                } else {
                    console.log('No hay sexos');
                    setSexos([]);
                }
                if(response.data.etnias) {
                    setEtnias(response.data.etnias);
                } else {
                    console.log('No hay etnias');
                    setEtnias([]);
                }
                if(response.data.discapacidadcausas) {
                    setDiscapacidadcausas(response.data.discapacidadcausas);
                } else {
                    console.log('No hay causas de discapacidad');
                    setDiscapacidadcausas([]);
                }
                if(response.data.gestantes) {
                    setGestantes(response.data.gestantes);
                } else {
                    console.log('No hay gestantes');
                    setGestantes([]);
                }
                if(response.data.enfermedades) {
                    setEnfermedades(response.data.enfermedades);
                } else {
                    console.log('No hay enfermedades');
                    setEnfermedades([]);
                }
                if (response.data.diferencial) {
                    setPendingResetData(response.data.diferencial);
                } else {
                    
                    Mensaje('Error', response.data.message, 'error');
                }
            })
            .catch((error) => {
                setCargando(false);
                Mensaje('Error', 'Error al cargar los datos', 'error');
            })
            .finally(() => {
                setCargando(false);
            });
        }
        fethcData();
    }, [iddx, token]);
    const FormReset = (data) => {
        const fechahoy = new Date().toLocaleDateString('en-CA')
        const fechaNacimiento = data?.dif_2_2_1_f_nacimiento
            ? new Date(data.dif_2_2_1_f_nacimiento)
            : new Date(fechahoy);
        if (data?.dif_2_2_1_f_nacimiento) {
            fechaNacimiento.setDate(fechaNacimiento.getDate() + 1);
        }
        reset((prevValues) => ({
            ...prevValues,
            iddx: data?.iddx || '',
            dif_2_2_1_f_nacimiento: fechaNacimiento,
            id_2_1_sexo: data?.id_2_1_sexo?.toString() || '',
            dif_2_2_2_edad: data?.dif_2_2_2_edad || '',
            dif_2_2_3_c_ninos_0_y_5_anios: data?.dif_2_2_3_c_ninos_0_y_5_anios || '0',
            dif_2_2_4_c_ninas_0_y_5_anios: data?.dif_2_2_4_c_ninas_0_y_5_anios || '0',
            dif_2_2_5_c_ninos_6_y_12_anios: data?.dif_2_2_5_c_ninos_6_y_12_anios || '0',
            dif_2_2_6_c_ninas_6_y_12_anios: data?.dif_2_2_6_c_ninas_6_y_12_anios || '0',
            dif_2_2_7_c_hombres_13_y_17_anios: data?.dif_2_2_7_c_hombres_13_y_17_anios || '0',
            dif_2_2_8_c_mujeres_13_y_17_anios: data?.dif_2_2_8_c_mujeres_13_y_17_anios || '0',
            dif_2_2_9_c_hombres_18_y_28_anios: data?.dif_2_2_9_c_hombres_18_y_28_anios || '0',
            dif_2_2_10_c_mujeres_18_y_28_anios: data?.dif_2_2_10_c_mujeres_18_y_28_anios || '0',
            dif_2_2_11_c_hombres_29_y_59_anios: data?.dif_2_2_11_c_hombres_29_y_59_anios || '0',
            dif_2_2_12_c_mujeres_29_y_59_anios: data?.dif_2_2_12_c_mujeres_29_y_59_anios || '0',
            dif_2_2_13_c_hombres_60_anios_en_adelante: data?.dif_2_2_13_c_hombres_60_anios_en_adelante || '0',
            dif_2_2_14_c_mujeres_60_anios_en_adelante: data?.dif_2_2_14_c_mujeres_60_anios_en_adelante || '0',
            dif_2_2_15_t_hombres_en_el_grupo_familiar: data?.dif_2_2_15_t_hombres_en_el_grupo_familiar || '0',
            dif_2_2_16_t_mujeres_en_el_grupo_familiar: data?.dif_2_2_16_t_mujeres_en_el_grupo_familiar || '0',
            dif_2_2_17_t_personas_en_el_hogar: data?.dif_2_2_17_t_personas_en_el_hogar || '0',
            dif_2_3_1_resguardo_o_comunidad: data?.dif_2_3_1_resguardo_o_comunidad || '',
            dif_2_3_etnia: data?.dif_2_3_etnia || '',
            dif_2_4_lgbti: data?.dif_2_4_lgbti || '',
            dif_2_5_1_1_ceguera: data?.dif_2_5_1_1_ceguera || false,
            dif_2_5_1_2_sordera: data?.dif_2_5_1_2_sordera || false,
            dif_2_5_1_3_mudez: data?.dif_2_5_1_3_mudez || false,
            dif_2_5_1_4_cognitiva_mental: data?.dif_2_5_1_4_cognitiva_mental || false,
            dif_2_5_1_5_paralisisausencia_miemb_sup: data?.dif_2_5_1_5_paralisisausencia_miemb_sup || false,
            dif_2_5_1_6_paralisisausencia_miemb_inf: data?.dif_2_5_1_6_paralisisausencia_miemb_inf || false,
            dif_2_5_1_7_detalle_discapacidad: data?.dif_2_5_1_7_detalle_discapacidad || '',
            dif_2_5_2_causa_discapacidad: data?.dif_2_5_2_causa_discapacidad || '',
            dif_2_6_1_gestante_lactante: data?.dif_2_6_1_gestante_lactante || '',
            dif_2_6_2_quien: data?.dif_2_6_2_quien || '',
            dif_2_7_1_enfermedad_cronica_o_terminal: data?.dif_2_7_1_enfermedad_cronica_o_terminal || '',
            dif_2_7_2_quien_y_cual_enfermedad: data?.dif_2_7_2_quien_y_cual_enfermedad || '',
            
        }));
    };

    function irAUbicacion(){
        if(estadoDx >= 4)
        Navigate(`/dx/ubicacion/${iddx}/${idrecepcion}`);
    }
    const onSubmit = async (data) => {
            setCargando(true);
            let url;
            url = '/diagnostico/guardardiferenciales';
            try {
                data.dif_2_2_1_f_nacimiento = (moment(data.dif_2_2_1_f_nacimiento).isValid()) ? moment(data.dif_2_2_1_f_nacimiento).format('YYYY-MM-DD') : null;
                const response = await apiService.post(url, data, token);
                if(response.status === 200){
                    setEstadoDx(response.data.estadodx);
                    Mensaje('Guardar', JSON.stringify(response.data.message), 'success');
                }
            } catch (error) {
                if(error.status === 422){
                    Mensaje('Guardar', JSON.stringify(error.response.data.errors), 'error');
                }else if(error.status === 409){
                    Mensaje('Guardar', JSON.stringify(error.response.data), 'error');
                }else {
                    Mensaje('Guardar', 'Error al guardar los datos', 'error');
                    console.error('Error fetching data:', error);
                }
                    
            } finally {
                setCargando(false);
            }
        };    
    return (
        
        <div className="content-wrapper">
            <SeccionPageHeader
                title="Diagnostico base - Diferenciales"
                idCabezaFamilia="1"
                url="/dx/diagnosticodx"
                nombreurl="Diagnostico dx"
                nombreform="Diferenciales"
            />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <HeaderDXReloj startTime={fechaInicioAtencion} estadoDx={estadoDx} />
                <MenuEnlacesDX iddx={iddx} idrecepcion={idrecepcion} buttonActive={3} estadoDx={estadoDx}/>

                <div id="formDiagnostico" className="card">
                    <div className="row">
                    <div className="col-md-12">
                        <div className="nav-tabs-custom">
                        <div className="tab-content">
                            <h4>2. CARACTER&iacute;STICAS DIFERENCIALES</h4><p className="text-danger">Los datos de este formulario son autogenerados, tener en cuenta de guardarlos una ves revisados.</p>
                            <form className="form-horizontal" onSubmit={handleSubmit(onSubmit)}>
                                <div className="card">
                                    <div className='card-body'>
                                        <div className="row">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                <label htmlFor="slcid_2_1_sexo">2.1. Sexo</label>
                                                <select
                                                    className="form-control"
                                                    id="id_2_1_sexo"
                                                    style={{ width: "100%" }}
                                                    {...register("id_2_1_sexo", { required: "Este campo es obligatorio" })}
                                                    disabled
                                                >
                                                    <option value="">Seleccione opci&oacute;n</option>
                                                    {sexos.map((sexo) => (
                                                                <option key={sexo.id} value={sexo.id}>
                                                                    {sexo.sex_nombre}
                                                                </option>
                                                            ))}
                                                </select>
                                                </div>  
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label htmlFor="txtdif_2_2_1_f_nacimiento">2.2.1. Fecha de Nacimiento </label>
                                                    <div className="input-group">
                                                        <Controller
                                                            control={control}
                                                            name="dif_2_2_1_f_nacimiento"
                                                            render={({ field }) => (
                                                                <div style={{ border: '1px solid #ced4da', borderRadius: 4, padding: 2, display: 'inline-block' }}>
                                                                    <DatePicker
                                                                    placeholderText="fecha"
                                                                    onChange={(date) => {field.onChange(date); CalcularEdad(date);}}
                                                                    showMonthDropdown
                                                                    showYearDropdown
                                                                    dropdownMode="select"
                                                                    selected={field.value ? new Date(`${field.value}`) : null}
                                                                    customInput={<CustomInput />}
                                                                    locale="es"
                                                                    dateFormat="yyyy-MM-dd"
                                                                    maxDate={new Date()}
                                                                    disabled
                                                                    />
                                                                </div>
                                                            )}
                                                        />
                                                        {errors.dif_2_2_1_f_nacimiento && (
                                                            <span className="text-danger">{errors.dif_2_2_1_f_nacimiento.message}</span>
                                                        )}
                                                        
                                                    </div>
                                                    <span id="infotxtdif_2_2_1_f_nacimiento">Fecha de Nacimiento de la persona diagnosticada. Formato de la fecha es: DD/MM/AAAA</span>
                                                </div>  
                                            </div>
                                            <div className="col-md-2">
                                                <div className="form-group">
                                                <label htmlFor="txtdif_2_2_2__edad">2.2.2. Edad</label>
                                                <input
                                                    id="txtdif_2_2_2__edad"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Edad"
                                                    {...register("dif_2_2_2_edad", { required: "Este campo es obligatorio" })}
                                                    disabled
                                                />
                                                {errors.dif_2_2_2_edad && (
                                                    <span className="text-danger">{errors.dif_2_2_2_edad.message}</span>
                                                )}
                                                </div>  
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-7">
                                                <label htmlFor='txtdif_2_2_3__c_ninos_0_y_5_anios'>2.2.3. Cantidad de niños del hogar entre 0 y 5 años de edad</label>  
                                            </div>
                                            <div className="col-md-1">
                                                <input
                                                    id="txtdif_2_2_3__c_ninos_0_y_5_anios"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Cant."
                                                    {...register("dif_2_2_3_c_ninos_0_y_5_anios", { required: "Este campo es obligatorio" })}
                                                    disabled
                                                />
                                                {errors.dif_2_2_3_c_ninos_0_y_5_anios && (
                                                    <span className="text-danger">{errors.dif_2_2_3_c_ninos_0_y_5_anios.message}</span>
                                                )}
                                            </div>  
                                            </div>
                                            <div className="row">
                                            <div className="col-md-7">
                                                <label htmlFor='txtdif_2_2_4__c_ninas_0_y_5_anios'>2.2.4. Cantidad de niñas del hogar entre 0 y 5 años de edad</label>  
                                            </div>
                                            <div className="col-md-1">
                                                <input
                                                    id="txtdif_2_2_4__c_ninas_0_y_5_anios"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Cant."
                                                    {...register("dif_2_2_4_c_ninas_0_y_5_anios", { required: "Este campo es obligatorio" })}
                                                    disabled
                                                />
                                                {errors.dif_2_2_4_c_ninas_0_y_5_anios && (
                                                    <span className="text-danger">{errors.dif_2_2_4_c_ninas_0_y_5_anios.message}</span>
                                                )}
                                            </div>  
                                            </div>
                                            <div className="row">
                                            <div className="col-md-7">
                                                <label htmlFor='txtdif_2_2_5__c_ninos_6_y_12_anios'>2.2.5. Cantidad de niños del hogar entre 6 y 12 años de edad</label>  
                                            </div>
                                            <div className="col-md-1">
                                                <input
                                                    id="txtdif_2_2_5__c_ninos_6_y_12_anios"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Cant."
                                                    {...register("dif_2_2_5_c_ninos_6_y_12_anios", { required: "Este campo es obligatorio" })}
                                                    disabled
                                                />
                                                {errors.dif_2_2_5_c_ninos_6_y_12_anios && (
                                                    <span className="text-danger">{errors.dif_2_2_5_c_ninos_6_y_12_anios.message}</span>
                                                )}
                                            </div>  
                                            </div>
                                            <div className="row">
                                            <div className="col-md-7">
                                                <label htmlFor='txtdif_2_2_6__c_ninas_6_y_12_anios'>2.2.6. Cantidad de niñas del hogar entre 6 y 12 años de edad</label>  
                                            </div>
                                            <div className="col-md-1">
                                                <input
                                                    id="txtdif_2_2_6__c_ninas_6_y_12_anios"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Cant."
                                                    {...register("dif_2_2_6_c_ninas_6_y_12_anios", { required: "Este campo es obligatorio" })}
                                                    disabled
                                                />
                                                {errors.dif_2_2_6_c_ninas_6_y_12_anios && (
                                                    <span className="text-danger">{errors.dif_2_2_6_c_ninas_6_y_12_anios.message}</span>
                                                )}
                                            </div>  
                                        </div>
                                        <div className="row">
                                            <div className="col-md-7">
                                                <label htmlFor='txtdif_2_2_7__c_hombres_13_y_17_anios'>2.2.7. Cantidad hombres del hogar entre 13 y 17 años de edad</label>  
                                            </div>
                                            <div className="col-md-1">
                                                <input
                                                    id="txtdif_2_2_7__c_hombres_13_y_17_anios"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Cant."
                                                    {...register("dif_2_2_7_c_hombres_13_y_17_anios", { required: "Este campo es obligatorio" })}
                                                    disabled
                                                />
                                                {errors.dif_2_2_7_c_hombres_13_y_17_anios && (
                                                    <span className="text-danger">{errors.dif_2_2_7_c_hombres_13_y_17_anios.message}</span>
                                                )}
                                            </div>  
                                        </div>
                                        <div className="row">
                                            <div className="col-md-7">
                                                <label htmlFor='txtdif_2_2_8__c_mujeres_13_y_17_anios'>2.2.8. Cantidad de mujeres del hogar entre 13 y 17 años de edad</label>  
                                            </div>
                                            <div className="col-md-1">
                                                <input
                                                    id="txtdif_2_2_8__c_mujeres_13_y_17_anios"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Cant."
                                                    {...register("dif_2_2_8_c_mujeres_13_y_17_anios", { required: "Este campo es obligatorio" })}
                                                    disabled
                                                />
                                                {errors.dif_2_2_8_c_mujeres_13_y_17_anios && (
                                                    <span className="text-danger">{errors.dif_2_2_8_c_mujeres_13_y_17_anios.message}</span>
                                                )}
                                            </div>  
                                        </div>
                                        <div className="row">
                                            <div className="col-md-7">
                                                <label htmlFor='txtdif_2_2_9__c_hombres_18_y_28_anios'>2.2.9. Cantidad de hombres del hogar entre 18 y 28 años de edad</label>  
                                            </div>
                                            <div className="col-md-1">
                                                <input
                                                    id="txtdif_2_2_9__c_hombres_18_y_28_anios"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Cant."
                                                    {...register("dif_2_2_9_c_hombres_18_y_28_anios", { required: "Este campo es obligatorio" })}
                                                    disabled
                                                />
                                                {errors.dif_2_2_9_c_hombres_18_y_28_anios && (
                                                    <span className="text-danger">{errors.dif_2_2_9_c_hombres_18_y_28_anios.message}</span>
                                                )}
                                            </div>  
                                        </div>
                                        <div className="row">
                                            <div className="col-md-7">
                                                <label htmlFor='txtdif_2_2_10__c_mujeres_18_y_28_anios_'>2.2.10. Cantidad de mujeres del hogar entre 18 y 28 años de edad</label>  
                                            </div>
                                            <div className="col-md-1">
                                                <input
                                                    id="txtdif_2_2_10__c_mujeres_18_y_28_anios_"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Cant."
                                                    {...register("dif_2_2_10_c_mujeres_18_y_28_anios", { required: "Este campo es obligatorio" })}
                                                    disabled
                                                />
                                                {errors.dif_2_2_10_c_mujeres_18_y_28_anios && (
                                                    <span className="text-danger">{errors.dif_2_2_10_c_mujeres_18_y_28_anios.message}</span>
                                                )}
                                            </div>  
                                        </div>
                                        <div className="row">
                                            <div className="col-md-7">
                                                <label htmlFor='txtdif_2_2_11__c_hombres_29_y_59_anios'>2.2.11. Cantidad de hombres del hogar entre 29 y 60 años de edad</label>  
                                            </div>
                                            <div className="col-md-1">
                                                <input
                                                    id="txtdif_2_2_11__c_hombres_29_y_59_anios"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Cant."
                                                    {...register("dif_2_2_11_c_hombres_29_y_59_anios", { required: "Este campo es obligatorio" })}
                                                    disabled
                                                />
                                                {errors.dif_2_2_11_c_hombres_29_y_59_anios && (
                                                    <span className="text-danger">{errors.dif_2_2_11_c_hombres_29_y_59_anios.message}</span>
                                                )}
                                            </div>  
                                        </div>
                                        <div className="row">
                                            <div className="col-md-7">
                                                <label htmlFor='txtdif_2_2_12__c_mujeres_29_y_59_anios'>2.2.12. Cantidad de mujeres del hogar entre 29 y 60 años de edad</label>  
                                            </div>
                                            <div className="col-md-1">
                                                <input
                                                    id="txtdif_2_2_12__c_mujeres_29_y_59_anios"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Cant."
                                                    {...register("dif_2_2_12_c_mujeres_29_y_59_anios", { required: "Este campo es obligatorio" })}
                                                    disabled
                                                />
                                                {errors.dif_2_2_12_c_mujeres_29_y_59_anios && (
                                                    <span className="text-danger">{errors.dif_2_2_12_c_mujeres_29_y_59_anios.message}</span>
                                                )}
                                            </div>  
                                        </div>
                                        <div className="row">
                                            <div className="col-md-7">
                                                <label htmlFor='txtdif_2_2_13__c_hombres_60_anios_en_adelante'>2.2.13. Cantidad de hombres del hogar de 61 años en adelante</label>  
                                            </div>
                                            <div className="col-md-1">
                                                <input
                                                    id="txtdif_2_2_13__c_hombres_60_anios_en_adelante"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Cant."
                                                    {...register("dif_2_2_13_c_hombres_60_anios_en_adelante", { required: "Este campo es obligatorio" })}
                                                    disabled
                                                />
                                                {errors.dif_2_2_13_c_hombres_60_anios_en_adelante && (
                                                    <span className="text-danger">{errors.dif_2_2_13_c_hombres_60_anios_en_adelante.message}</span>
                                                )}
                                            </div>  
                                        </div>
                                        <div className="row">
                                        <div className="col-md-7">
                                            <label htmlFor='txtdif_2_2_14__c_mujeres_60_anios_en_adelante'>2.2.14. Cantidad de mujeres del hogar de 61 años en adelante</label>  
                                        </div>
                                        <div className="col-md-1">
                                            <input
                                                id="txtdif_2_2_14__c_mujeres_60_anios_en_adelante"
                                                type="text"
                                                className="form-control"
                                                placeholder="Cant."
                                                {...register("dif_2_2_14_c_mujeres_60_anios_en_adelante", { required: "Este campo es obligatorio" })}
                                                disabled
                                            />
                                            {errors.dif_2_2_14_c_mujeres_60_anios_en_adelante && (
                                                <span className="text-danger">{errors.dif_2_2_14_c_mujeres_60_anios_en_adelante.message}</span>
                                            )}
                                        </div>  
                                        </div>
                                        <div className="row">
                                        <div className="col-md-7">
                                            <label htmlFor='txtdif_2_2_15__t_hombres_en_el_grupo_familiar'>2.2.15. Total hombres en el grupo familiar</label>  
                                        </div>
                                        <div className="col-md-1">
                                            <input
                                                id="txtdif_2_2_15__t_hombres_en_el_grupo_familiar"
                                                type="text"
                                                className="form-control"
                                                placeholder="Cant."
                                                {...register("dif_2_2_15_t_hombres_en_el_grupo_familiar", { required: "Este campo es obligatorio" })}
                                                disabled
                                            />
                                            {errors.dif_2_2_15_t_hombres_en_el_grupo_familiar && (
                                                <span className="text-danger">{errors.dif_2_2_15_t_hombres_en_el_grupo_familiar.message}</span>
                                            )}
                                        </div>  
                                        </div>
                                        <div className="row">
                                        <div className="col-md-7">
                                            <label htmlFor='txtdif_2_2_16__t_mujeres_en_el_grupo_familiar'>2.2.16. Total mujeres en el grupo familiar</label>  
                                        </div>
                                        <div className="col-md-1">
                                            <input
                                                id="txtdif_2_2_16__t_mujeres_en_el_grupo_familiar"
                                                type="text"
                                                className="form-control"
                                                placeholder="Cant."
                                                {...register("dif_2_2_16_t_mujeres_en_el_grupo_familiar", { required: "Este campo es obligatorio" })}
                                                disabled
                                            />
                                            {errors.dif_2_2_16_t_mujeres_en_el_grupo_familiar && (
                                                <span className="text-danger">{errors.dif_2_2_16_t_mujeres_en_el_grupo_familiar.message}</span>
                                            )}
                                        </div>  
                                        </div>
                                        <div className="row">
                                        <div className="col-md-7">
                                            <label htmlFor='txtdif_2_2_17__t_personas_en_el_hogar'>2.2.17. Total personas en el hogar</label>  
                                        </div>
                                        <div className="col-md-1">
                                            <input
                                                id="txtdif_2_2_17__t_personas_en_el_hogar"
                                                type="text"
                                                className="form-control"
                                                placeholder="Cant."
                                                {...register("dif_2_2_17_t_personas_en_el_hogar", { required: "Este campo es obligatorio" })}
                                                disabled
                                            />
                                            {errors.dif_2_2_17_t_personas_en_el_hogar && (
                                                <span className="text-danger">{errors.dif_2_2_17_t_personas_en_el_hogar.message}</span>
                                            )}
                                        </div>  
                                        </div>
                                        <hr/>
                                        <div className="row">
                                        <div className="col-md-4">
                                            <div className="form-group">
                                            <label htmlFor='slcdif_2_3__etnia'>2.3. Etnia</label>
                                            <select
                                                className="form-control"
                                                id="slcdif_2_3__etnia"
                                                style={{ width: "100%" }}
                                                {...register("dif_2_3_etnia", { required: "Este campo es obligatorio" })}
                                                disabled
                                            >
                                                <option value="">Seleccione etnia</option>
                                                {etnias.map((etnia) => (
                                                    <option key={etnia.id} value={etnia.id}>
                                                        {etnia.id} {etnia.min_minoria}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.dif_2_3_etnia && (
                                                <span className="text-danger">{errors.dif_2_3_etnia.message}</span>
                                            )}
                                            <span id="infoslcdif_2_3__etnia">Una persona pertenece a una etnia, cuando se reconoce como tal.</span>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                            <label htmlFor='txtdif_2_3_1_resguardo_o_comunidad'>2.3.1 Resguardo o Comunidad a la que pertenece</label>
                                            <input
                                                id="txtdif_2_3_1_resguardo_o_comunidad"
                                                type="text"
                                                className="form-control"
                                                placeholder="Resguardo o comunidad"
                                                {...register("dif_2_3_1_resguardo_o_comunidad", { required: watch('dif_2_3_etnia').value === 2 ? "Este campo es obligatorio" : false })}
                                                disabled
                                            />
                                            {errors.dif_2_3_1_resguardo_o_comunidad && (
                                                <span className="text-danger">{errors.dif_2_3_1_resguardo_o_comunidad.message}</span>
                                            )}
                                            <span id="infotxtdif_2_3_1_resguardo_o_comunidad">Nombre del Resguardo o Comunidad a la que pertenece.</span>
                                            </div>  
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                            <label htmlFor='txtdif_2_4__lgbti'>2.4. Poblaci&oacute;n OSIEGD</label>
                                            <input
                                                id="txtdif_2_4__lgbti"
                                                type="text"
                                                className="form-control"
                                                placeholder="Ej. Ana Perez 18."
                                                {...register("dif_2_4_lgbti")}
                                                disabled
                                            />
                                            {errors.dif_2_4_lgbti && (
                                                <span className="text-danger">{errors.dif_2_4_lgbti.message}</span>
                                            )}
                                            <span id="infotxtdif_2_4__lgbti">Nombre y edad de la persona o las personas del grupo familiar que hacen parte de la poblaci&oacute;n OSIEGD</span>
                                            </div>  
                                        </div>
                                        </div>
                                        <div className="card-title">
                                        <h5><b>2.5.1. Tipo de Discapacidad</b></h5>
                                        </div>
                                        <div className="row">                  
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                <input type="checkbox" 
                                                    {...register('dif_2_5_1_1_ceguera')}
                                                    onChange={(e) => {
                                                        setValue("dif_2_5_1_1_ceguera", e.target.checked)
                                                    }}
                                                    className="custom-control-input" id="dif_2_5_1_1_ceguera"
                                                    disabled/>
                                                <label className="custom-control-label" htmlFor="dif_2_5_1_1_ceguera"> 2.5.1.1. Ceguera</label>
                                                <span id="infochkdif_2_5_1_1__ceguera"> Seleccione si alguna persona de la familia presenta situacion de discapacidad.</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        {...register('dif_2_5_1_2_sordera')}
                                                        onChange={(e) => {
                                                            setValue("dif_2_5_1_2_sordera", e.target.checked);
                                                        }}
                                                        className="custom-control-input"
                                                        id="dif_2_5_1_2_sordera"
                                                        disabled
                                                    />
                                                    <label className="custom-control-label" htmlFor="dif_2_5_1_2_sordera">
                                                        2.5.1.2. Sordera
                                                    </label>
                                                    <span id="infochkdif_2_5_1_2__sordera">
                                                        Seleccione si alguna persona de la familia presenta situacion de discapacidad.
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        {...register('dif_2_5_1_3_mudez')}
                                                        onChange={(e) => {
                                                            setValue("dif_2_5_1_3_mudez", e.target.checked);
                                                        }}
                                                        className="custom-control-input"
                                                        id="dif_2_5_1_3_mudez"
                                                        disabled
                                                    />
                                                    <label className="custom-control-label" htmlFor="dif_2_5_1_3_mudez">
                                                        2.5.1.3. Mudez
                                                    </label>
                                                    <span id="infochkdif_2_5_1_3__mudez">
                                                        Seleccione si alguna persona de la familia presenta situacion de discapacidad.
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        {...register('dif_2_5_1_4_cognitiva_mental')}
                                                        onChange={(e) => {
                                                            setValue("dif_2_5_1_4_cognitiva_mental", e.target.checked);
                                                        }}
                                                        className="custom-control-input"
                                                        id="dif_2_5_1_4_cognitiva_mental"
                                                        disabled
                                                    />
                                                    <label className="custom-control-label" htmlFor="dif_2_5_1_4_cognitiva_mental">
                                                        2.5.1.4. Cognitiva/Mental
                                                    </label>
                                                    <span id="infochkdif_2_5_1_4__cognitiva_mental">
                                                        Seleccione si alguna persona de la familia presenta situaci&oacute;n de discapacidad.
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <div className="custom-control custom-switch">
                                                    <input
                                                        type="checkbox"
                                                        {...register('dif_2_5_1_5_paralisisausencia_miemb_sup')}
                                                        onChange={(e) => {
                                                            setValue("dif_2_5_1_5_paralisisausencia_miemb_sup", e.target.checked);
                                                        }}
                                                        className="custom-control-input"
                                                        id="dif_2_5_1_5_paralisisausencia_miemb_sup"
                                                        disabled
                                                    />
                                                    <label className="custom-control-label" htmlFor="dif_2_5_1_5_paralisisausencia_miemb_sup">
                                                        2.5.1.5. Par&aacute;lisis/ausencia miemb. Sup.
                                                    </label>
                                                    <span id="infochkdif_2_5_1_5__paralisisausencia_miemb_sup">
                                                        Seleccione si alguna persona de la familia presenta situacion de discapacidad.
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                        <div className="form-group">
                                            <div className="custom-control custom-switch">
                                                <input
                                                    type="checkbox"
                                                    {...register('dif_2_5_1_6_paralisisausencia_miemb_inf')}
                                                    onChange={(e) => {
                                                        setValue("dif_2_5_1_6_paralisisausencia_miemb_inf", e.target.checked);
                                                    }}
                                                    className="custom-control-input"
                                                    id="dif_2_5_1_6_paralisisausencia_miemb_inf"
                                                    disabled
                                                />
                                                <label className="custom-control-label" htmlFor="dif_2_5_1_6_paralisisausencia_miemb_inf">
                                                    2.5.1.6. Par&aacute;lisis/ausencia miemb. Inf.
                                                </label>
                                                <span id="infochkdif_2_5_1_6__paralisisausencia_miemb_Inf">
                                                    Seleccione si alguna persona de la familia presenta situaci&oacute;n de discapacidad.
                                                </span>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                            <label htmlFor='txtdif_2_5_1_7_detalle_discapacidad'>2.5.1.7 Detalle Discapacidad</label>
                                            <input
                                                id="txtdif_2_5_1_7_detalle_discapacidad"
                                                type="text"
                                                className="form-control"
                                                placeholder="Ej. Ana Perez 18."
                                                {...register("dif_2_5_1_7_detalle_discapacidad", { required: "Este campo es obligatorio" })}
                                                disabled
                                            />
                                            {errors.dif_2_5_1_7_detalle_discapacidad && (
                                                <span className="text-danger">{errors.dif_2_5_1_7_detalle_discapacidad.message}</span>
                                            )}
                                            <span id="infotxtdif_2_5_1_7_detalle_discapacidad">Escriba a manera de observaci&oacute;n el nombre y la edad de la persona o personas con discapacidad. </span>
                                            </div>  
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-group">
                                            <label htmlFor='txtdif_2_5_2__causa_discapacidad'>2.5.2. Causa de la Discapacidad</label>
                                                <input
                                                    id="txtdif_2_5_2__causa_discapacidad"
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Causa de la discapacidad"
                                                    {...register("dif_2_5_2_causa_discapacidad")}
                                                    disabled
                                                />
                                                {errors.dif_2_5_2_causa_discapacidad && (
                                                    <span className="text-danger">{errors.dif_2_5_2_causa_discapacidad.message}</span>
                                                )}
                                                <span id="infotxtdif_2_5_2__causa_discapacidad">
                                                    Escriba la causa de la discapacidad si aplica.
                                                </span>
                                            </div>
                                        </div>                  
                                        </div>
                                        <div className="card-title">
                                        <h5><b>2.6. Mujeres Gestantes y/o Lactantes</b></h5>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-5">
                                            <div className="form-group">
                                            <label htmlFor='slcdif_2_6_1__gestante_lactante'>2.6.1. ¿Alg&uacute;n integrante del Hogar es Gestante y/o Lactante?</label>
                                            <select
                                                className="form-control"
                                                id="slcdif_2_6_1__gestante_lactante"
                                                style={{ width: "100%" }}
                                                {...register("dif_2_6_1_gestante_lactante", { required: "Este campo es obligatorio" })}
                                                disabled
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                <option value="0">No</option>
                                                <option value="1">1 - Gestante.</option>
                                                <option value="2">2 - Lactante.</option>
                                                <option value="3">3 - Ambas.</option>
                                                <option value="4">4 - Ninguna.</option>
                                            </select>
                                            {errors.dif_2_6_1_gestante_lactante && (
                                                <span className="text-danger">{errors.dif_2_6_1_gestante_lactante.message}</span>
                                            )}
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-group">
                                            <label htmlFor='txtdif_2_6_2__quien'>2.6.2. ¿Qui&eacute;n?</label>
                                            <input
                                                id="txtdif_2_6_2__quien"
                                                type="text"
                                                className="form-control"
                                                placeholder="Ej. Ana Perez 18."
                                                {...register("dif_2_6_2_quien")}
                                                disabled
                                            />
                                            {errors.dif_2_6_2_quien && (
                                                <span className="text-danger">{errors.dif_2_6_2_quien.message}</span>
                                            )}
                                            <span id="infotxtdif_2_6_2__quien">Escriba a manera de observaci&oacute;n el nombre y la edad de la mujer o mujeres gestantes y/o lactantes.</span>
                                            </div>  
                                        </div>
                                        </div>
                                        <div className="card-title">
                                        <h5><b>2.7. Enfermedad Cr&oacute;nica o Terminal</b></h5>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='slcdif_2_7_1__enfermedad_cronica_o_terminal'>2.7.1. ¿Alg&uacute;n miembro del Hogar tiene alg&uacute;n tipo de enfermedad Cr&oacute;nica o Terminal?</label>
                                            <select
                                                className="form-control"
                                                id="slcdif_2_7_1__enfermedad_cronica_o_terminal"
                                                style={{ width: "100%" }}
                                                {...register("dif_2_7_1_enfermedad_cronica_o_terminal", { required: "Este campo es obligatorio" })}
                                                disabled
                                            >
                                                <option value="">Seleccione opci&oacute;n</option>
                                                <option value="0">No</option>
                                                <option value="1">1 - Enfermedad cronica.</option>
                                                <option value="2">2 - Enfermedad terminal.</option>
                                                <option value="3">3 - Ninguna.</option>
                                                <option value="4">4 - Ambas.</option>
                                            </select>
                                            {errors.dif_2_7_1_enfermedad_cronica_o_terminal && (
                                                <span className="text-danger">{errors.dif_2_7_1_enfermedad_cronica_o_terminal.message}</span>
                                            )}
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                            <label htmlFor='txtdif_2_7_2__quien_y_cual_enfermedad'>2.7.2. ¿Qui&eacute;n? y ¿Cuál enfermedad?</label>
                                            <input
                                                id="txtdif_2_7_2__quien_y_cual_enfermedad"
                                                type="text"
                                                className="form-control"
                                                placeholder="Quien y cual enfermedad"
                                                {...register("dif_2_7_2_quien_y_cual_enfermedad")}
                                                disabled
                                            />
                                            {errors.dif_2_7_2_quien_y_cual_enfermedad && (
                                                <span className="text-danger">{errors.dif_2_7_2_quien_y_cual_enfermedad.message}</span>
                                            )}
                                            <span id="infotxtdif_2_7_2__quien_y_cual_enfermedad">Escriba a manera de observaci&oacute;n el nombre, la edad y la enfermedad del miembro o miembros del hogar que tienen alg&uacute;n tipo de enfermedad Cronica o Terminal.</span>
                                            </div>  
                                        </div>
                                        </div>
                                        <div className="row">
                                        <div className="col-md-6">
                                            <button id="btnDxActualizarDiferenciales" type="submit" className="btn btn-block btn-primary btn-sm">Actualizar y seguir con Ubicaci&oacute;n
                                            </button>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                <SweetAlert2
                    {...swalProps}
                    didClose={() => setSwalProps({})}
                    onConfirm={() => {
                        if (swalProps.icon === 'success') {
                            setSwalProps({});
                            irAUbicacion();
                        } else {
                            setSwalProps({});
                        }
                    }}
                />
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
        
    )
  }